module.exports = __webpack_public_path__ + "static/media/checkBlue.2ebc5e46.svg";